import React, { useEffect, useState } from "react";
import {
  ContactWrapper,
  Links
} from "./DownloadsElements";
import ScrollAnimation from "react-animate-on-scroll";
import { listDownloads } from '../../services/contentService';

function Downloads() {
  const [items, setItems] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    listDownloads()
      .then((rows) => {
        if (cancelled) return;
        setItems(rows);
      })
      .catch((e) => {
        if (cancelled) return;
        setError(e.message);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <ContactWrapper id="downloads">
      <div className="Container">
        <div className="SectionTitle" style={{ textAlign: "center" }}>Download Section</div>
        <div className="BigCard">
          <ScrollAnimation animateIn="fadeInLeft">
            <Links>
              {error ? <div style={{ color: 'crimson' }}>{error}</div> : null}
              {items.map((it) => (
                <a
                  key={it.id || `${it.title}-${it.url}`}
                  className="downloads__item"
                  href={it.url}
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className="downloads__title">{it.title}</div>
                </a>
              ))}
              {items.length === 0 && !error ? (
                <div style={{ opacity: 0.8 }}>No downloads available.</div>
              ) : null}
            </Links>
          </ScrollAnimation>
        </div>
      </div>
    </ContactWrapper>
  );
}

export default Downloads;
